function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPractitioner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46.97 61.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M33.66,35.2a15.73,15.73,0,1,0-15.44,0,16.6,16.6,0,0,0-1.67.47,2,2,0,0,0,.64,3.89,2,2,0,0,0,.63-.1c.27-.09.54-.15.81-.23a7.29,7.29,0,0,0,14.58,0v0c4.77,1.36,8.07,4.76,8.07,8.6a7.47,7.47,0,0,1-7.46,7.46h-16a7.78,7.78,0,0,1-1.53-.15A2,2,0,1,0,15.51,59a11.4,11.4,0,0,0,2.34.24h16A11.49,11.49,0,0,0,45.28,47.73C45.28,42,40.48,36.91,33.66,35.2ZM14.18,21.51A11.74,11.74,0,1,1,30.64,32.25a1.8,1.8,0,0,0-.38.16,11.72,11.72,0,0,1-16.08-10.9Zm11.74,21a3.3,3.3,0,0,1-3.29-3.29V36.9a15.64,15.64,0,0,0,6.58,0v2.33A3.3,3.3,0,0,1,25.92,42.52Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45,0H8.39a2,2,0,0,0,0,4H45a2,2,0,0,0,0-4Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.63,6.16a2,2,0,0,0-2,2v5.38a2,2,0,0,0,4,0V8.16A2,2,0,0,0,43.63,6.16Z",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,41.81A8,8,0,1,0,4,52.7v7.67a1.45,1.45,0,0,0,2.47,1L8,59.85l1.53,1.54a1.45,1.45,0,0,0,2.47-1V52.7A8,8,0,0,0,15,41.81ZM8,49.81a4,4,0,1,1,4-4A4,4,0,0,1,8,49.81Z",
    style: {
      fill: "currentColor"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPractitioner);
export default __webpack_public_path__ + "static/media/practitioner.35a9535d.svg";
export { ForwardRef as ReactComponent };